import { TenantCustomer } from '~/tenants/common/TenantPersona';

export default class NepCustomer extends TenantCustomer {}
